import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { Router } from "@angular/router";
import { LocalStorageService } from '../../shared/services/storage/local-storage.service';
import { CookiesService } from '../../shared/services/storage/cookies.service';
import { ActivatedRoute } from '@angular/router';
import { EesDesService } from '../../shared/services/ees-des.service';
import { CookieService } from 'ngx-cookie-service';
import { LogoutService } from '../../shared/services/logout.service';

declare const google: any;

@Component({
  selector: 'app-login-v2',
  templateUrl: './login-v2.component.html',
  styleUrls: ['./login-v2.component.scss'],
  providers: [WebServiceService, LocalStorageService, CookiesService,EesDesService]
})

export class LoginV2Component implements OnInit, OnDestroy {
  message = 'Dear Users, Please note that our server will be on regular maintenance from 00:00 Hours on May 21st, 2023 to 09:00 Hours on May 21st, 2023. Please plan your work accordingly.  Thanks';
  is_vendor_login:boolean=false;
  responseData: any = {}
  baseurl: string = "";
  userEmail: any = '';
  password: any = '';
  userNewEmail: any = '';
  isLoading: boolean = false;
  forgotPasswordInput: boolean = false;
  disableButton: boolean = false;
  year: any = new Date().getFullYear();
  rememberMe: boolean = false;
  counter: number = 0;
  show:any='0';
company_data:any={}
getParamList:any=[];
getKeysList:any=[];
isSSO:boolean=false;
isSocialLogin:boolean=false
userType:any = '2'
msLoginData:any={}
isProgressing: boolean = false;
isVendorLoginClick: boolean = true;
public_reg: boolean = false;
public_reg_link: any = "";
isvenRegProgressing: boolean = false;
venReg : any = { "vendor_name": "", "email": "", "mobile": "", "gstin": "", "otp": "", }
showNewVenOTP: boolean = false;
showReGenOTP: boolean = false;
getDataContent: string;
  is_disable: any;
  constructor(public webService: WebServiceService,
    private router: Router,
    private toasterService: ToasterService,
    public _localStorageService: LocalStorageService,
    private titleService: Title,
    private _cookieService: CookiesService,
    private route: ActivatedRoute,public eesdesService:EesDesService,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private logoutService: LogoutService


  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      let keys:any=[];
      keys=Object.keys(params)?Object.keys(params):[]
      if(keys.length>0)
      {
      this.getKeysList=keys?keys:[]
      if((this.getKeysList.indexOf("c")>-1))
      {
      this.isSSO=true;
      // console.log(this.getKeysList);
      }
      if((this.getKeysList.indexOf("public_reg")>-1))
      {
        this.public_reg = true;
      }
      this.getParamList.push(params);
      // console.log(params)
      // console.log(this.getParamList); // Print the parameter to the console.
      }
  });

  if(localStorage.getItem('signin_token') && localStorage.getItem('signin_token') != undefined && localStorage.getItem('signin_token') != "")
    {
      // this.isSSO = true;
      this.isProgressing = true;
      this.isLoading = true;
      this.google_login(localStorage.getItem('signin_token'));
    }

  }
  source_data:any={type:'NORMAL',data:''}
  companyThemeBlockColor: any = "";
  CompanyThemetextColor: any = "";
  isVendorLoginByEmail:boolean = false;
  ngOnInit() {
    const encryptedData = sessionStorage.getItem("rfq-by-vendor");
    if(encryptedData == '1'){
        this.hideEmpLogin = true;
        this.is_vendor_login = true;
        this.isVendorLoginClick = false;
        this.userType = 1;
        this.isVendorLoginByEmail = true;
    }
    // this.route.queryParams.subscribe(params => {
    //   if (params['data']) {
    //     let paramData = params['data'];
    //     if(paramData){
    //       this.hideEmpLogin = true;
    //       this.is_vendor_login = true;
    //     }
    //   }
    // });
    this.msLoginData=sessionStorage.getItem('claims')?sessionStorage.getItem('claims'):''
    if(this.msLoginData!='' && this.msLoginData!=null)
    {
      this.msLoginData=JSON.parse(this.msLoginData)
      this.isSSO=true
      this.isSocialLogin=true
    }
    if(this.public_reg) {
      let rawParam = this.activatedRoute.snapshot.queryParamMap.get('public_reg');

      console.log("Raw Param:", rawParam); // Debugging Step

      if (rawParam) {
        // Step 1: Decode URL-encoded characters
        let decodedParam = decodeURIComponent(rawParam);

        // replace space with + in decodedParam
        let modifiedString = decodedParam.replace(/ /g, "+");

        // // Step 2: Fix any double escaping (convert `\/` to `/`)
        // decodedParam = decodedParam.replace(/\\\//g, "/");
        // console.log("After Fixing Slashes:", decodedParam);

        // // Step 3: Fix escaped backslashes (`\\` should become `\`)
        // decodedParam = decodedParam.replace(/\\\\/g, "\\");
        // console.log("Final Processed Param:", decodedParam);

        this.public_reg_link = modifiedString;

        // let request = {
        //   "code": this.public_reg_link
        // }

        // console.log(request);

        this.verifyLink();
      }

      
    }else{
      this.getDataFromCookie();
    }
    // console.log("this.public_reg_link", this.public_reg_link)
    this.showIssue(false);
    this.showSSO(this.isSSO);
    let value = location.href;
    let test :any= value.split('=')?value.split('='):[];
    console.log(test);
    this.getDataContent = this.activatedRoute.snapshot.queryParamMap.get('bulk_id');
    this.getDataContent = this.getDataContent ? this.getDataContent : '';
    if(this.getDataContent != null || this.getDataContent != ""){
      localStorage.setItem('bulkdata_redirectAUrl', this.getDataContent.toString());
    }
    if(Array.isArray(test) && !this.isSSO && !this.IsVailidLink)
    {
      if(test.length>1 && (this.getDataContent != null || this.getDataContent != ""))
      {
        let enc_data: string = this.route.snapshot.queryParamMap.get('data');
        console.log(enc_data);
        console.log(this.isSSO);
this.source_data.data=enc_data?enc_data:''
this.source_data.type='MAIL'
      }
    }
    this.getLoginData(window.location.hostname);
    this.restrictUserLoginWithEmailPassword(window.location.hostname);

    this.checkAuth();
    let temp = this._localStorageService.getUserId() ? this._localStorageService.getUserId() : ''
    if (temp != "" && temp != undefined && temp != '') {
      // this.toasterService.pop("info", "Info", "Already login");
      this.getCompanySetUpData();

    }
    if(!this.isSSO)
    {
    if (this._cookieService.getrememberMe() == '1') {
      this.userEmail = (this._cookieService.getUserName())
      this.password = (atob(this._cookieService.getPassword()));
      this.rememberMe = true;
    } else {
      this.userEmail = "";
      this.password = '';
      this.rememberMe = false;
    }
    this.companyThemeBlockColor = this._localStorageService.getCompanyTheme() ? this._localStorageService.getCompanyTheme() : "#035168";
    this.CompanyThemetextColor = this._localStorageService.getCompanyThemeColor() ? this._localStorageService.getCompanyThemeColor() : "#FFFFFF";
  }
    this.titleService.setTitle("Login");
    if (!this.webService.isOnline()) {
      this.toasterService.pop("error", "Error", "Internet is not working");
      return false;
    }
    this.validateUser();
    document.getElementById("base-div").style.paddingTop = "0px";
    document.getElementById("base-div").style.marginLeft = "0px";

    // Load the Google Sign-In API script dynamically
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      this.renderGoogleSignInButton();
    };
    document.head.appendChild(script);
    
  }
  ngOnDestroy(): void {
    sessionStorage.removeItem("rfq-by-vendor");
  }
  getLoginBackground()
  {
    // this.title='Login to your TYASuite';
    this.background_image="https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/images/login-bg.png";
    this.logo="https://d38cf3wt06n6q6.cloudfront.net/tyasuitefront/images/white-logo.png"
  }
  title:any='Login to your TYASuite';
  background_image:any='';
  logo:any='';
  url_host:any=window.location.hostname=='localhost'?'ad.intelaccounts.in':window.location.hostname;

  getLoginData(url)
  {
    let requestObj = {
      "url_host":(url=='localhost'||url==''||url==undefined)?'ad.intelaccounts.in':window.location.hostname,
    }
       if(this.background_image!='')
    {
      return;
    }
    this.webService.commonPostMethod("Companies/view_client_setup", requestObj).
      subscribe(
        data => {
          if (data.status) {
            if(!Array.isArray(data.response))
            {
            this.title=data.response.title?data.response.title:'';
            // this.title='Login to your TYASuite.'
            this.background_image=data.response.background_image?data.response.background_image:''
            this.url_host=data.response.url_host?data.response.url_host:'';
            this.logo=data.response.logo?data.response.logo:'';
            }
            else
            {
              this.getLoginBackground()

            }
          }
          else {
            this.getLoginBackground()
          }

        },
        error => {
          this.getLoginBackground()

        }
      );
  }
  getObjectKeyIndex(obj, keyToFind) {
    var i = 0, key;

    for (key in obj) {
        if (key == keyToFind) {
            return i;
        }

        i++;
    }

    return -1;
}
  urlList: any = [];
  ssoText:any=' We are fetching your Activities ...'
  checkAuth() {
    if (this._localStorageService.getUserId() == undefined ||
      this._localStorageService.getUserId() == null) {
      if(this.getParamList.length==1)
      {
        if(this.isSSO)
        {
          this.isSSO=true;
          let d:any=(this.getParamList[0].c?this.getParamList[0].c:{email:'',password:''})
          if(d.indexOf(" ")>-1)
          {
            d=d.replace(/ /g,"+");
          }
          d=this.webService.get('',d,'1')
          // console.log(d);
          // console.log(this.getParamList);
          this.userEmail=d.email?d.email:'';
          this.password=d.password?d.password:'';
          this.login('SSO');
        }
      }
      if(this.isSocialLogin)
      {
        this.userEmail=this.msLoginData.preferred_username?this.msLoginData.preferred_username:'';
          this.password='';
          this.login('SSO');
      }
    }
    else {
      this.getCompanySetUpData();
    }
  }

  validateUser() {
    if (this._localStorageService.getUserId() != "" && this._localStorageService.getUserId() != undefined) {
      // this.toasterService.pop("info", "Info", "Already login");
      this.getCompanySetUpData();
    }
  }
  resetSSO()
  {
    this.isSSO=false;
    this.ssoText=''
    window.sessionStorage.clear()
    this.webService.redirectURL('/login');

    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      this.renderGoogleSignInButton();
    };
    document.head.appendChild(script);

  }
  login(type) {
    if (this.userEmail == '' || this.userEmail == undefined) {
      if(this.isSSO || this.isSocialLogin)
      {
      this.ssoText="Login Credential is invalid"
      }
      this.toasterService.pop("error", "Error", "Enter email id");
      return false;
    }
    if (this.password == '' || this.password == undefined) {
      if(this.isSSO && !this.isSocialLogin)
      {
      this.ssoText="Login Credential is invalid"
      }
      if(!this.isSocialLogin)
      {
      this.toasterService.pop("error", "Error", "Enter password");
      return false;
      }
    }
    this.isLoading = true
    let requestObj = {
      is_sso:type=='SSO'?'1':'0',
      "email": this.userEmail,
      "password":(this.eesdesService.set(this.password,'is_login_psw')?this.eesdesService.set(this.password,'is_login_psw'):'')
    }

    // console.log(requestObj)
    let url:any='';
    if(this.is_vendor_login)
    {
      url='/Vendor_management/loginVendor';
    }
    else
    {
      url='/login/ajax_login';
    }
    if(this.isSocialLogin)
    {
      delete requestObj['is_sso']
      requestObj['social_login']='1'
      requestObj['password']=''
      requestObj['company_id']='0'
      requestObj['email']=(this.eesdesService.set(this.userEmail,'is_login_psw')?this.eesdesService.set(this.userEmail,'is_login_psw'):'')
      url='/login/social_login';
    }
    this.webService.commonPostMethod(url, requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.responseData = data;
            if(data.message!='' && data.message!=undefined)
            {
              this.toasterService.pop('success', 'Success',data.message);

            }
            if (this.responseData.user.role != 'vendor' && !this.is_vendor_login) {
              this.responseData.user.enable_mfa = this.responseData.user.enable_mfa ? this.responseData.user.enable_mfa : "0";
              this.showOtp = this.responseData.user.enable_mfa=='1' ? true : false;
              this.user_id = this.responseData.user.id;
              if(this.responseData.user.enable_mfa!="1") {
                this.setUserVariables();
              }
            } else {

              if(this.public_reg){
                  const companyDetail = { companyTitle: this.companyTitle, companyLogo: this.companyLogo,  public_reg_link :this.public_reg_link };
                  this.cookieService.set('companyDetail', JSON.stringify(companyDetail), 7, '/');
              }
              
              this.setUserVariables();
            }
          } else {
            window.sessionStorage.clear()
            this.toasterService.pop('error', 'Error', data.message);
            this.isLoading = false;
            if(this.isSSO)
            {
            this.ssoText="Login Credential is invalid"
            }
          }
          this.isLoading = false;

        }, error => {
           window.sessionStorage.clear()
          this.toasterService.pop('error', 'Error','Something Went Wrong');
          this.isLoading=false;
          this.showIssue(false);
          this.showSSO(false)
          window.sessionStorage.clear()
          this.isSocialLogin=false
          this.isSSO=false
          this.msLoginData={}
        }
      );
  }

  setUserVariables() {
    localStorage.setItem('is_enc_on',this.eesdesService.set('1','is_enc_on'));
    localStorage.setItem('is_vendor_login',this.eesdesService.set(this.is_vendor_login?'1':'0'));
    localStorage.setItem("user_data", this.eesdesService.set(JSON.stringify(this.responseData.user)));
    localStorage.setItem('bulkdata_redirectAUrl', this.eesdesService.set(this.getDataContent?this.getDataContent:'', 'bulkdata_redirectAUrl'));
    this.isLoading = false;
    localStorage.setItem("emp_role", this.eesdesService.set(this.responseData.user.role));

    if (this.responseData.user.role != 'vendor' && !this.is_vendor_login) {
      localStorage.setItem("ven_role", this.eesdesService.set(""));

      this.getUserDetails(this.responseData.user.id);
      // this.getUserDetailsForDepartment(this.responseData.user.id)
    }

    if (this.responseData.user.is_multi_email_login == true && this.is_vendor_login) 
    {
      this.webService.redirectURL('/select-user')
    }else{
      if (this.responseData.user.role == 'vendor' && this.is_vendor_login) {
        localStorage.setItem("ven_role", this.eesdesService.set("vendor"));
        localStorage.setItem("emp_role", this.eesdesService.set("vendor"));
  
        this.getVendorDetails(this.responseData.user.id);
      }
    }
    
    this._cookieService.setUserName(this.userEmail);
    this._cookieService.setPassword(btoa(this.password));
    this._cookieService.setrememberMe(this.rememberMe?'1':'0');
    this.setHttpCookie({"action":"set",
    "cookie_name": "accesstoken",
    "cookie_value": this.eesdesService.set(this.userEmail,'accesstoken'),
    "expire": "72000"})
    this.setHttpCookie({"action":"set",
    "cookie_name": "accesskey",
    "cookie_value": this.eesdesService.set(btoa(this.password),'accesskey'),
    "expire": "72000"})
    this.setHttpCookie({"action":"set",
    "cookie_name": "accessrem",
    "cookie_value": this.eesdesService.set(this.rememberMe?'1':'0','accessrem'),
    "expire": "72000"})
    // this.userLogin();
    this.isProgressing = false;

  }


  empDetails: any;
  getUserDetails(id) {
    this.isProgressing = true;
    let requestObj = {
      "emp_id": id == undefined || id == null ? 0 : id,
      "company_id":'0'
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }

    //employees/ajax_getsingemp
    //employees/ajax_getsingemp_companies_details
    this.webService.commonPostMethod('employees/ajax_getsingemp_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.empDetails = data;
            if (this.empDetails.empdata != undefined && this.empDetails.empdata != '') {


              if (this.empDetails.empdata.companies.length > 1) {
                this.isProgressing = false;
                this.webService.redirectURL('/my-companies')

              }
              else {
                if (this.empDetails.empdata) {
                  if (this.empDetails.empdata.companies) {
                    for (let j of this.empDetails.empdata.companies) {
                      if (j.employee_id == id) {
                        this.empDetails.empdata.employee_role = j.employee_role;
                        this.empDetails.empdata.employee_code = j.employee_code;
                        this.empDetails.empdata.company_id = j.company_id;
                        this.empDetails.empdata.company_title = j.company_title;
                        this.empDetails.empdata.company_code = j.company_code?j.company_code:'';

                        this.empDetails.empdata.company_logo = j.company_logo;
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        this.empDetails.empdata.company_theme = j.company_theme;
                        this.empDetails.empdata.company_theme_text = j.company_theme_text;
                        this.empDetails.empdata.allow_multiple_login=j.allow_multiple_login?j.allow_multiple_login:'0'
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        // j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        // localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                        // localStorage.setItem("department_id", j.department?j.department:'');
                        // localStorage.setItem("department_name", j.department_name?j.department_name:'');
                        // localStorage.setItem("profile_image", j.profile_image?j.profile_image:'');


                      }
                    }
                  }
                }
                // localStorage.setItem("company_id", this.eesdesService.set(this.empDetails.empdata.company_id));
                // localStorage.setItem("emp_role", this.eesdesService.set(this.empDetails.empdata.employee_role));
                // localStorage.setItem("company_title", this.eesdesService.set(this.empDetails.empdata.company_title));
                // localStorage.setItem("company_code", this.eesdesService.set(this.empDetails.empdata.company_code));

                // localStorage.setItem("company_logo", this.eesdesService.set(this.empDetails.empdata.company_logo));
                // localStorage.setItem("employee_code", this.eesdesService.set(this.empDetails.empdata.employee_code));
                // localStorage.setItem("company_theme", this.eesdesService.set(this.empDetails.empdata.company_theme));
                // localStorage.setItem("company_theme_text", this.eesdesService.set(this.empDetails.empdata.company_theme_text));
                 this.getAccessToken(this.empDetails.empdata.company_id,id);
                //  this.userLogin();
                this.getUserDetailsForDepartment()

              }
              this.isProgressing = false;
            }
            else {
              this.getAccessToken(this.empDetails.empdata.company_id,id);
              this.isProgressing = false;
            }

          } else if (data.status == false) {
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            this.isProgressing = false;
            return
          }
        }, error => {

          this.isProgressing = false;
        }
      );
  }
  already_active:boolean=false;
  already_active_msg:any=''
  getUserAccessToken(company_id,user_id) {
    this.isProgressing = true;
    let requestObj = {
      "company_id": company_id ? company_id : '0',
      "user_id":user_id?user_id:''
    }
    this.webService.commonPostMethod('User_session_management/generate_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            localStorage.setItem('user_access_token', this.eesdesService.set(data.response));
            this.isProgressing = false;
//             if(this.source_data.type=='MAIL')
// {
//   // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
//   let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
//   this.IsVailidLink(url);
// }
// else
// {
//   this.showIssue(false);
//   if(this.isSocialLogin)
//   {
//     this.webService.redirectURL('/my-companies');
//   }
//   else
//   {
//     this.getCompanySetUpData();
//   }
// }
if(this.responseData.user.role != 'vendor' && !this.is_vendor_login)
{
  sessionStorage.setItem('company_id', this.empDetails.empdata.company_id);
  localStorage.setItem("company_id", this.eesdesService.set(this.empDetails.empdata.company_id));
  localStorage.setItem("emp_role", this.eesdesService.set(this.empDetails.empdata.employee_role));
  localStorage.setItem("company_title", this.eesdesService.set(this.empDetails.empdata.company_title));
  localStorage.setItem("company_code", this.eesdesService.set(this.empDetails.empdata.company_code));

  localStorage.setItem("company_logo", this.eesdesService.set(this.empDetails.empdata.company_logo));
  localStorage.setItem("employee_code", this.eesdesService.set(this.empDetails.empdata.employee_code));
  localStorage.setItem("company_theme", this.eesdesService.set(this.empDetails.empdata.company_theme));
  localStorage.setItem("company_theme_text", this.eesdesService.set(this.empDetails.empdata.company_theme_text));

}
else
{
  sessionStorage.setItem('company_id', this.vendorDetails.vendordata.company_id);
  localStorage.setItem("company_id", this.eesdesService.set(this.vendorDetails.vendordata.company_id));
    localStorage.setItem("emp_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));
    localStorage.setItem("ven_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));

    localStorage.setItem("company_title", this.eesdesService.set(this.vendorDetails.vendordata.company_title));
    localStorage.setItem("company_code", this.eesdesService.set(this.vendorDetails.vendordata.company_code));

    localStorage.setItem("company_logo", this.eesdesService.set(this.vendorDetails.vendordata.company_logo));
    // console.log('vendor code 2='+this.vendorDetails.vendordata.employee_code)
    localStorage.setItem("employee_code", this.eesdesService.set(this.vendorDetails.vendordata.employee_code));
    localStorage.setItem("company_theme", this.eesdesService.set(this.vendorDetails.vendordata.company_theme));
    localStorage.setItem("company_theme_text", this.eesdesService.set(this.vendorDetails.vendordata.company_theme_text));
}
this.userLogin();
if(this.source_data.type=='MAIL' && !this.isValidOpenLink)
{
  // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
  let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
  this.IsVailidLink(url);
}
else
{
  this.showIssue(false);
  if(this.isSocialLogin)
  {
    this.webService.redirectURL('/my-companies');
  }
  else
  {
    this.getCompanySetUpData();
  }
}
if(this.isSSO)
            {
              this.showSSO(false);
            }
          }
          else if(data.already_active)
          {
            this.isProgressing = false;
            this.already_active=true;
            this.already_active_msg=data.message;
            this.showIssue(true);
          }
          else {
            this.isProgressing = false;
            if (this.eesdesService.get('company_id',localStorage.getItem('company_id')) == null || this.eesdesService.get('company_id',localStorage.getItem('company_id')) == "0") {
              if(this.source_data.type=='MAIL')
              {
                // window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
                let url=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;
                this.IsVailidLink(url);
              }
              else
              {
                if(this.isSocialLogin)
                {
                  this.webService.redirectURL('/my-companies');
                }
                else
                {
                  this.getCompanySetUpData();
                }
              }

            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              this.isProgressing = false;
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = "";
            }
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.isProgressing = false;
        }
      );
  }
  getAccessToken(id,user_id) {
    this.isProgressing = true;
    let requestObj = {
      "company_id": id ? id : '0',
    }
    this.webService.commonPostMethod('Companies/company_get_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this._cookieService.setCompanyAccessToken(data.response);
            localStorage.setItem('access_token', this.eesdesService.set(data.response));
            this.setHttpCookie({"action":"set",
            "cookie_name": "access_token",
            "cookie_value": this.eesdesService.set(data.response,'access_token'),
            "expire": "72000"})
            this.company_data={company_id:id,user_id:user_id};
            this.getUserAccessToken(id,user_id);
            this.isProgressing = false;
            }
            else {
              this.toasterService.pop("error", "Error", data.message);
              this.isProgressing = false;
              window.localStorage.clear();
              window.location.href = "";
            }

        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
          this.isProgressing = false;
        }
      );
  }
  vendorDetails: any
  getVendorDetailsOld(vendorId) {
    let requestObj = {
      "vendor_id": vendorId,
    }
    this.webService.commonPostMethod('Vendor_management/ajax_getsingvendor_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.vendorDetails = data.response;
            if (this.vendorDetails != undefined && this.vendorDetails != '') {
              if (this.vendorDetails.companies.length > 1) {

if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/my-companies?data="+this.source_data.data;

}
else
{
  this.webService.redirectURL('/my-companies');

}

              }
              else {
                if (this.vendorDetails.companies) {
                  for (let i of this.vendorDetails.companies) {
                    localStorage.setItem("employee_code", this.eesdesService.set(i.vendor_code));

                  }
                }
                if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;

}
else
{
  this.getCompanySetUpData();
}
              }
            }
            else {
              if (this.vendorDetails.companies) {
                for (let i of this.vendorDetails.companies) {
                  localStorage.setItem("employee_code", this.eesdesService.set(i.vendor_code));

                }
              }
              if(this.source_data.type=='MAIL')
{
  window.location.href=window.location.origin+"/master/#/rfq-by-vendor?data="+this.source_data.data;

}
else
{
  this.getCompanySetUpData();
}
            }

          } else if (data.status == false) {
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            return
          }
        }, error => {
          this.toasterService.pop('error','Error','Something Went Wrong');
        }
      );
  }
  getVendorDetails(id) {
    this.isProgressing = true;
    let requestObj = {
      "vendor_id": id == undefined || id == null ? 0 : id,
      "company_id":'0'
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }
    //employees/ajax_getsingvendor
    //employees/Vendor_management/ajax_getsingvendor_companies_details
    this.vendorDetails={};
    this.webService.commonPostMethod('Vendor_management/ajax_getsingvendor_companies_details', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.vendorDetails = data;
            this.isProgressing = false;
            if(!Array.isArray(this.vendorDetails.vendordata))
            {
            if (this.vendorDetails.vendordata != undefined && this.vendorDetails.vendordata != '') {


              if (this.vendorDetails.vendordata.companies.length > 1) {
                if(this.source_data.type=='MAIL')
                {
                  let url=window.location.origin+"/#/my-companies?data="+this.source_data.data;
                  this.IsVailidLink(url);

                }
                else
                {
                this.webService.redirectURL('/my-companies')
                }
              }
              else {
                if (this.vendorDetails.vendordata) {
                  if (this.vendorDetails.vendordata.companies) {
                    for (let j of this.vendorDetails.vendordata.companies) {
                      if (j.vendor_id == id) {
                        j.company_setup=j.company_setup?j.company_setup:{'MINUTES_UNITL_AUTO_LOGOUT':10};

                        this.vendorDetails.vendordata.employee_role = this.vendorDetails.vendordata.role?this.vendorDetails.vendordata.role:'';
                        this.vendorDetails.vendordata.employee_code = j.vendor_code;
                        this.vendorDetails.vendordata.company_id = j.company_id;
                        this.vendorDetails.vendordata.company_title = j.company_title;
                        this.vendorDetails.vendordata.company_code = j.company_code?j.company_code:'';

                        this.vendorDetails.vendordata.company_logo = j.company_logo;
                        this.vendorDetails.vendordata.company_theme = j.company_theme ? j.company_theme: '#035168';
                        this.vendorDetails.vendordata.company_theme_text = j.company_theme_text ? j.company_theme_text: '#FFFFFF';
                        this.vendorDetails.vendordata.allow_multiple_login=j.allow_multiple_login?j.allow_multiple_login:'0'
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
                        j.company_setup.enable_strict_auto_logout_policy = j.company_setup.enable_strict_auto_logout_policy ? j.company_setup.enable_strict_auto_logout_policy : '0';
                        localStorage.setItem('enable_strict_auto_logout_policy',j.company_setup.enable_strict_auto_logout_policy);
                        localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                        localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                        localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));


                      }
                    }
                  }
                }
                // localStorage.setItem("company_id", this.eesdesService.set(this.vendorDetails.vendordata.company_id));
                // localStorage.setItem("emp_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));
                // localStorage.setItem("ven_role", this.eesdesService.set(this.vendorDetails.vendordata.employee_role));

                // localStorage.setItem("company_title", this.eesdesService.set(this.vendorDetails.vendordata.company_title));
                // localStorage.setItem("company_code", this.eesdesService.set(this.vendorDetails.vendordata.company_code));

                // localStorage.setItem("company_logo", this.eesdesService.set(this.vendorDetails.vendordata.company_logo));
                // // console.log('vendor code 2='+this.vendorDetails.vendordata.employee_code)
                // localStorage.setItem("employee_code", this.eesdesService.set(this.vendorDetails.vendordata.employee_code));
                // localStorage.setItem("company_theme", this.eesdesService.set(this.vendorDetails.vendordata.company_theme));
                // localStorage.setItem("company_theme_text", this.eesdesService.set(this.vendorDetails.vendordata.company_theme_text));
                 this.getAccessToken(this.vendorDetails.vendordata.company_id,id);
                //  this.userLogin();

              }
              // this.userLogin();
            }
            else {
              this.getAccessToken(this.vendorDetails.vendordata.company_id,id);
            }

        // this.userLogin();

          }
          else
          {
            this.toasterService.pop('error', 'Error','Invalid Login');

            this.isLoading = false;
            this.isProgressing = false;
            return
          }
          } else{
            this.toasterService.pop('error', 'Oops', data.message);
            this.isLoading = false;
            this.isProgressing = false;
            return
          }
        }, error => {
          this.isProgressing = false;
        }
      );
      // // this.userLogin();
  }

  forgotPassword() {
    this.forgotPasswordInput = true;
    this.disableButton = false;
    this.userNewEmail = ""
  }

  goBack() {
    this.forgotPasswordInput = false;
    this.showOtp = false;
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      this.renderGoogleSignInButton();
    };
    document.head.appendChild(script);
  }

  validaeEmail() {
    if (this.userNewEmail == '' || this.userNewEmail == undefined) {
      this.toasterService.pop("error", "Error", "Enter email id");
      return false;
    }
    let host = this.webService.retrnAngularUrl();

    this.isLoading = true;
    let requestObj = {
      "email": this.userNewEmail,
      "url": host + "/#/reset-password",
      "user_type": this.userType ? this.userType : "2"
    }
    this.webService.commonPostMethod('Login_Exe/ajax_forget_pwd', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.toasterService.pop('success', 'Success', "Reset your password by clicking the link shared in your email" + ' ' + this.userNewEmail);
            this.isLoading = false;
            this.userNewEmail = "";
            this.disableButton = false;
          } else {
            this.toasterService.pop('error', 'Error', data.message);
            this.isLoading = false;
            return
          }
        }, error => {

        }
      );
  }
  showPassCode(status)
  {
  this.show=status.toString();
  //console.log(this.show)

  }

  //chanukya added for department details 2019-12-04
  getUserDetailsForDepartment() {
    let requestObj = {
      "company_id":this.empDetails.empdata.company_id ? this.empDetails.empdata.company_id : '',
      "emp_id": this.responseData.user.id ? this.responseData.user.id : '',
    }
    if(this.isSocialLogin)
    {
      requestObj['social_login']='1'
    }
    this.webService.commonPostMethod('employees/ajax_getsingemp', requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            let empDetails:any;
            empDetails = data;
            console.log(empDetails)
            if (empDetails.empdata != undefined && empDetails.empdata != '') {


              if (empDetails.empdata.companies.length > 1) {
                this.webService.redirectURL('/my-companies')


              }
              else {
                if (empDetails.empdata) {
                  if (empDetails.empdata.companies) {
                    for (let j of empDetails.empdata.companies) {
                      if (j.employee_id == this.responseData.user.id) {
                        j.company_setup = j.company_setup ? j.company_setup : {};
                        // localStorage.setItem("company_setup", JSON.stringify(j.company_setup));
                        j.company_setup.MINUTES_UNITL_AUTO_LOGOUT= j.company_setup.MINUTES_UNITL_AUTO_LOGOUT? j.company_setup.MINUTES_UNITL_AUTO_LOGOUT:10
                        localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',j.company_setup.MINUTES_UNITL_AUTO_LOGOUT)
                        localStorage.setItem("department_id", this.eesdesService.set(j.department?j.department:''));
                        localStorage.setItem("department_name", this.eesdesService.set(j.department_name?j.department_name:''));
                        localStorage.setItem("profile_image", this.eesdesService.set(j.profile_image?j.profile_image:''));


                      }
                    }
                  }
                }


              }
              // this.userLogin();
            }

            else {
            }

          }


        }, error => {

        }
      );
      // this.userLogin();
  }

  showTerms() {
    document.getElementById('termsModal').style.display = "block";
    document.getElementById('body').style.overflow = 'hidden';
  }

  hideTerms() {
    document.getElementById('termsModal').style.display = "none";
    document.getElementById('body').style.overflow = 'auto';
  }

  showPrivacy() {
    document.getElementById('privacyModal').style.display = "block";
    document.getElementById('body').style.overflow = 'hidden';
  }

  hidePrivacy() {
    document.getElementById('privacyModal').style.display = "none";
    document.getElementById('body').style.overflow = 'auto';
  }
  setLoginType()
  {
    this.showOtp = false;
    if(this.isLoading)
    {
      this.toasterService.pop('info','Info','Wait Already Some Process is running');
      return;
    }
    this.is_vendor_login=!this.is_vendor_login;
     this.userType = this.is_vendor_login == false ? '2' : '1';
  }
  IsVailidLink(url)
  {
    let requestObj:any={
      data:this.source_data.data?this.source_data.data:'',
    };
    this.webService.commonPostMethod("Vendor_management/ajax_decrypt_rfq_data", requestObj).
      subscribe(
        data => {
          if (data.status) {
            window.location.href=url;
          }
          else {
            this.toasterService.pop('error','Error',data.message);
            localStorage.clear();
            this.router.navigate(['/']);
          }
        },
        error => {
          this.toasterService.pop('error','Error','Something Went Wrong');
          localStorage.clear();
          this.router.navigate(['/']);
        }
      );
  }
  showIssue(flag: boolean) {
    if (flag) {
      document.getElementById("IssueSidenavUserSession").style.width = "35%";
      document.getElementById("showIssueModelUserSession").style.display = "block";
      document.body.style.backgroundColor = "rgba(0,0,0,0.4)";
    } else {
      document.getElementById("IssueSidenavUserSession").style.width = "0";
      document.getElementById("showIssueModelUserSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  showSSO(flag: boolean) {
    console.log('flag='+flag);
    if(document.getElementById("IssueSSOSession")!=null)
    {
    if (flag) {
      window.sessionStorage.clear()
      document.getElementById("IssueSSOSession").style.width = "35%";
      document.getElementById("showSSOModelSession").style.display = "block";
      document.body.style.backgroundColor = "#006287";
    } else {
      document.getElementById("IssueSSOSession").style.width = "0";
      document.getElementById("showSSOModelSession").style.display = "none";
      document.body.style.backgroundColor = "#f0f0f1";
    }
  }
  }
  buttonProgressing:boolean=false
  destroyUserToken() {
    let requestObj = {
      "company_id": this.company_data.company_id ? this.company_data.company_id : '0',
    }
    this.buttonProgressing=true
    this.webService.commonPostMethod('User_session_management/destroy_token', requestObj).
      subscribe(
        data => {
          if (data.status) {
            this.buttonProgressing=false
            this.getUserAccessToken(this.company_data.company_id,this.company_data.user_id);
            }
            else {
              this.buttonProgressing=false
              this.toasterService.pop("error", "Error", data.message);
              window.localStorage.clear();
              window.sessionStorage.clear()
              window.location.href = "";
            }
            this.buttonProgressing=false
        }, error => {
          this.buttonProgressing=false
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  detectMob() {
    let cls:any='sidenav_progress'
    if (( window.innerWidth <= 800 ) && ( window.innerHeight <= 700 ) )
    {
      cls=cls+" sidenav_progressMobile"
    }
    if(!this.already_active)
    {
      cls=''
    }
    return cls
  }
  setHttpCookie(payload) {

    this.webService.commonPostMethod('login/cookies', payload).
      subscribe(
        data => {
          if (data.status) {
            }
            else {
            }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  detectDivMob() {
    let cls:any=''
    if (( window.innerWidth <= 800 ) && ( window.innerHeight <= 700 ) )
    {
      cls=cls+" SSODiv"
    }
    if(!this.isSSO)
    {
      cls=''
    }
    return cls
  }
  msLogin()
  {
    let redirectUrl = '/#';
    let url='/'
    let origin = window.location.origin;
    redirectUrl = origin + '/third-party-login' + redirectUrl + url;
    window.location.href = redirectUrl;
  }
  company_setup: any = {};
  getCompanySetUpData() {
    //Check if AutoLogout flag is set (last tab was closed or browser/system shutdown)
    if (localStorage.getItem('AutoLogout') == 'true') {
      console.log('AutoLogout is true, performing logout before redirecting to dashboard');
      this.toasterService.pop("info", "Info", "Your Session Expired");
      this.logoutService.logout([], 'force');
      return;
    }
    
    // Check if session expired based on last active time
    const lastActiveTime = localStorage.getItem('last_active_time');
    const minutesUntilAutoLogout = localStorage.getItem('MINUTES_UNITL_AUTO_LOGOUT');
    
    if (lastActiveTime && minutesUntilAutoLogout) {
      try {
        const lastActiveDate = new Date(lastActiveTime);
        const minutesToAdd = parseFloat(minutesUntilAutoLogout);
        
        if (!isNaN(lastActiveDate.getTime()) && !isNaN(minutesToAdd)) {
          // Calculate expiry time by adding minutes to last active time
          const expiryTime = new Date(lastActiveDate.getTime() + (minutesToAdd * 60 * 1000));
          const currentTime = new Date();
          
          // Calculate time difference between current time and last active time in milliseconds
          const timeDifference = currentTime.getTime() - lastActiveDate.getTime();
          const threeMinutesInMs = 3 * 60 * 1000; // 1 minute in milliseconds (changed from 3 minutes)
          // If expiry time is less than current time OR user was inactive for more than 1 minute, session has expired
          if ((expiryTime < currentTime) || (timeDifference > threeMinutesInMs)) {
            this.toasterService.pop("info", "Info", "Your Session Expired");
            this.logoutService.logout([], 'force');
            return;
          }
        }
      } catch (error) {
        console.error('Error checking session expiry:', error);
      }
    }
    
    let req = {
      "company_id": this._localStorageService.getEmpCompanyId() == undefined ? "0" : this._localStorageService.getEmpCompanyId(),
      variable_list:['redirect_vendor_profile_page','MINUTES_UNITL_AUTO_LOGOUT','enable_strict_auto_logout_policy','landing_url','auto_logout_user_for_different_domain','allowed_domain_mail'],
      component:this.constructor.name?this.constructor.name:'',
      "check_ven_pro_acc": this.is_vendor_login ? '1' : '0',
      "has_comp_access": '1',
    }
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany_limited_as_requested", req).subscribe(
      data => {
        if (data.status) {
          this.company_setup={}
          this.company_setup=data.response ? data.response : {}
          this.company_setup.MINUTES_UNITL_AUTO_LOGOUT = this.company_setup.MINUTES_UNITL_AUTO_LOGOUT ? this.company_setup.MINUTES_UNITL_AUTO_LOGOUT : 10;
          localStorage.setItem('MINUTES_UNITL_AUTO_LOGOUT',this.company_setup.MINUTES_UNITL_AUTO_LOGOUT);
          this.company_setup.enable_strict_auto_logout_policy = this.company_setup.enable_strict_auto_logout_policy ? this.company_setup.enable_strict_auto_logout_policy : '0';
          localStorage.setItem('enable_strict_auto_logout_policy',this.company_setup.enable_strict_auto_logout_policy);
          this.company_setup.redirect_vendor_profile_page = this.company_setup.redirect_vendor_profile_page ? this.company_setup.redirect_vendor_profile_page : '0';
          let has_access = data.has_access ? data.has_access : false;

          this.company_setup.landing_url=this.company_setup.landing_url?this.company_setup.landing_url:'1';
          data.has_comp_access = data.has_comp_access ? data.has_comp_access : '0';
          this.company_setup.landing_url = data.has_comp_access=='1' ? this.company_setup.landing_url : '1';
          this.company_setup.self_ven_reg_msg = this.company_setup.self_ven_reg_msg ? this.company_setup.self_ven_reg_msg : "By registering I hereby agree to pay TYASuite or any other agency the Vendor Portal Charges of Rs. 1,200 plus GST/year. I understand that my access will be blocked if payment is not made within 3 working days.";
          this.company_setup.auto_logout_user_for_different_domain = this.company_setup.auto_logout_user_for_different_domain ? this.company_setup.auto_logout_user_for_different_domain : '0';
          this.company_setup.allowed_domain_mail = this.company_setup.allowed_domain_mail ? this.company_setup.allowed_domain_mail : '';

          let navigateToComplianceDashboard = data.has_comp_access=='1' ? true : false;
          
          // let tmpMenu = this.webService.getMenuByUrl('/my-dashboard');

          // if(tmpMenu)
          // {
          //   console.log(tmpMenu);
          //   return;
          // }

          // if(tmpMenu && tmpMenu.submenu && tmpMenu.submenu.length > 0)
          // {
          //   // console.log(tmpMenu);
          //   let tmpObj = tmpMenu.submenu.find(o => o.aurl == '/my-dashboard');
          //   if(tmpObj)
          //   {
          //     navigateToComplianceDashboard = true;              
          //   }
          // }
          if (this.company_setup.auto_logout_user_for_different_domain === '1' && window.location.hostname !== this.company_setup.allowed_domain_mail) {
            this.toasterService.pop("info", "Info", `Kindly use the domain "${this.company_setup.allowed_domain_mail}" to access your account.`);
            setTimeout(() => {
              window.localStorage.clear();
              window.sessionStorage.clear();
              this.webService.redirectURL('/login');
            }, 1000)
            return false;
          }
          
          // Check user role for conditional redirect
          let userRole = this.eesdesService.get('emp_role', localStorage.getItem('emp_role'));
          
          if(this.company_setup.landing_url =='2' && navigateToComplianceDashboard){
            window.location.href=window.location.origin+'/compliance/#/my-dashboard';
          } else {
            // Redirect to /company if user role is not 'editor', otherwise dashboard
            if(userRole && userRole == 'editor') {

              this.webService.redirectURL('/company');
            } else {

              this.webService.redirectURL('/dashboard');
            }
          }
        
          if(this.company_setup.redirect_vendor_profile_page=="1" && this.is_vendor_login) {
            if(has_access) {
              this.webService.redirectURL('/vendorprofile');
            } else {
              this.webService.redirectURL('/dashboard');
            }
          } else {
            // Redirect to /company if user role is not 'editor', otherwise dashboard
            if(userRole && userRole == 'editor') {
              this.webService.redirectURL('/company');
            } else {
              this.webService.redirectURL('/dashboard');
            }
          }
        }
        else {
          this.toasterService.pop('error', "Error", data.message);
        }
      }, error => {
        this.toasterService.pop("error", "Error", "Something Went Wrong");
      }
    )
  }

  showOtp: boolean = false;
  otp: any = "";
  user_id: any = "";
  verifyOtp() {
    if(this.otp=="") {
      this.toasterService.pop("error", "Error", "Please enter otp to proceed.");
      return false;
    }
    let req:any={
      "user_id": this.user_id,
      "otp": this.otp
    }
    this.webService.commonPostMethod('authorization/validate_otp', req).
      subscribe(
        data => {
          if (data.status) {
            this.otp = "";
            this.setUserVariables();
          } else {
            this.toasterService.pop("error", "Error", data.message);
          }
        }, error => {
          this.toasterService.pop("error", "Error", "Something Went Wrong");
        }
      );
  }
  arrayForSearch: any = [];
  getModule(url) {
    let temp: any = [];
    temp = this.arrayForSearch.filter((v) => { return v.url == url })
    return temp[0] ? temp[0] : '';
  }
  userLogin() {

    let url: any = "/" + window.location.href.substring(window.location.href.lastIndexOf('/') + 1);

    let payload = {
      // company_id" :15,
      //   "url":"login",
      //   "project" : "login",
      //   "module_name" : "login",
      //   "user_id" : 4972 ,
      //   "activity_type" :"login
      // "url": url,
       "project": this.getModule(url).project ? this.getModule(url).project : 'operation',
      // "module_name": this.getModule(url).menuName ? this.getModule(url).menuName : '',
      // "module_id": this.getModule(url).id ? this.getModule(url).id : '',
      "activity_type": 'login',
      "company_id": this._localStorageService.getEmpCompanyId() ? this._localStorageService.getEmpCompanyId() : 0,
      'user_id': this._localStorageService.getUserId(),
      'user_role_id': this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) ? this.eesdesService.get('emp_role',localStorage.getItem('emp_role')) : '0'
    }
    this.webService.commonPostMethod("User_activity/save_user_activity", payload).
      subscribe(
        data => {
          if (data.status) {
            this.already_active_msg=data.message;

          }

        },
        error => {
        }
      );

  }

  openLink() {
    window.open("https://www.tyasuite.com/Compliance-Management?utm_source=mt.tyasuite&utm_medium=TYASuite_login_page", '_blank');
  }

  renderGoogleSignInButton() {
    google.accounts.id.initialize({
      // client_id: '736157933147-t824s8mj48vbqtthq263h4kcb14v2srv.apps.googleusercontent.com',
      client_id: '589114224735-q9tt3t4nh8jr709mqcclr3en5coe2tac.apps.googleusercontent.com',
      callback: (response: any) => {
        this.handleGoogleSignIn(response);
      }
    });
    const screenWidth = window.innerWidth;
    let buttonWidth = 142; // default
    let paddingLeft = 33;  // default

    if (screenWidth < 480) {
      buttonWidth = 110;
      paddingLeft = 18;
    } else if (screenWidth <= 760) {
      buttonWidth = 142;
      paddingLeft = 33;
    } else if (screenWidth >= 762 && screenWidth <= 800) {
      buttonWidth = 299;
      paddingLeft = 99;
    } else if (screenWidth >= 818 && screenWidth <= 900) {
      buttonWidth = 318;
      paddingLeft = 99;
    } else if (screenWidth > 900 && screenWidth <= 1025) {
      buttonWidth = 275;
      paddingLeft = 99;
    } else if (screenWidth >= 1280 && screenWidth <= 1300) {
      buttonWidth = 156;
      paddingLeft = 38;
    }
    const googleBtn = document.getElementById("google-signin-button");
    if (googleBtn) googleBtn.innerHTML = "";

    google.accounts.id.renderButton(
      document.getElementById('google-signin-button'),
      {
        'theme': 'rectangle',
        'width': buttonWidth,
        'height': 50,
        'scope': 'profile email',
        'text': 'signin',
        'longtitle': false,
        'size': 'medium',
      }
    );
    const innerDiv = googleBtn.querySelector("div > div > div") as HTMLElement;
    if (innerDiv) {
      innerDiv.style.paddingLeft = `${paddingLeft}px`;
    }
    const spanElement = googleBtn.querySelector(
      "div > div > div > div:nth-of-type(2) > span"
    ) as HTMLElement;
    
    if (spanElement) {
      spanElement.style.textAlign = "left";
    }
  }

 
handleGoogleSignIn(response: any) {
    if (response && response.credential) {
      let idToken = response.credential;

      localStorage.setItem("signin_token", idToken);
      this.isSSO = true;
      this.isLoading = true;
      this.isProgressing = true;    

      // let redirectUrl = '/#';
      // let url='/'
      // let origin = window.location.origin;
      // redirectUrl = origin + '/third-party-login' + redirectUrl + url;
      // window.location.href;
      window.location.reload();
        
    } else {
      console.error('Google Sign-In failed');
      this.isProgressing = false;
    }
}


  google_login(idToken) { 

    let requestObj = {}
    let url:any='';

    // this.isSSO = true;
    requestObj['social_login']='0'
    requestObj['password']=''
    requestObj['company_id']='0'
    requestObj['email']=''
    requestObj['google_login']='1'
    requestObj['google_login_cred']= idToken? idToken : ''
    url='/login/social_login';

    this.isLoading = true;
    this.isProgressing = true;    

    this.webService.commonPostMethod(url, requestObj).
      subscribe(
        data => {
          if (data.status == true) {
            this.responseData = data;
            if(data.message!='' && data.message!=undefined)
            {
              this.toasterService.pop('success', 'Success',data.message);
            }
            if (this.responseData.user.role != 'vendor' && !this.is_vendor_login) {
              this.responseData.user.enable_mfa = this.responseData.user.enable_mfa ? this.responseData.user.enable_mfa : "0";
              this.showOtp = this.responseData.user.enable_mfa=='1' ? true : false;
              this.user_id = this.responseData.user.id;
              if(this.responseData.user.enable_mfa!="1") {
                this.setUserVariables();
              }
            } else {
              this.setUserVariables();
            }
            this.isProgressing = false;

          } else {

            if(this.isSSO)
            {
            this.ssoText="Login Credential is invalid"
            }

            this.toasterService.pop('error', 'Error', data.message);
            this.isLoading = false;
            this.isProgressing = false;    
            window.sessionStorage.clear();
          }
          this.isLoading = false;
          localStorage.removeItem('signin_token');

        }, error => {
           window.sessionStorage.clear()
          this.toasterService.pop('error', 'Error','Something Went Wrong');
          this.isLoading=false;
          this.isProgressing = false;    
          this.showIssue(false);
          this.showSSO(false)
          window.sessionStorage.clear()
          this.isSocialLogin=false
          this.isSSO=false
          this.msLoginData={}
          localStorage.removeItem('signin_token');
        }
      );
  }

  isVendorLogin(){
    if(this.userType){
      if(this.userType == "2"){
        
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.onload = () => {
          this.renderGoogleSignInButton();
        };
        document.head.appendChild(script);

        this.isVendorLoginClick = true;
      }
      if(this.userType == "1"){
        this.isVendorLoginClick = false;
      }
    }
  }

  showvenRegPopup(elem : any) {
    this.sendOtpMsg = "";
    this.venReg = { "vendor_name": "", "email": "", "mobile": "", "gstin": "", "otp": "", }
    this.isValidateGstSuccess = false;
    this.isWrongGst = false;
    this.validateGstObj = {
      "name": "",
      "address": "",
      "pincode": "",
      "dst" : "",
      "gstin": "",
      "status": "",
    };
    this.perviousGstIn = "";
    this.reSendOtp = false;
    elem.open();
  }

  enableDisableOTP() {
    this.showNewVenOTP = false;
    this.showReGenOTP = false;
    this.reSendOtp = false;
  }

  enableReGenOTP() {
    this.showReGenOTP = true;
    this.venReg.otp = "";
  }

  venRegComId : any = 0;
  venRegComToken : any = "";
  isValidOpenLink : boolean = false;
  hideEmpLogin : boolean = false;
  companyTitle : any = "";
  companyLogo : any = "";
  verifyLink() {
    let requestObj = {
      "company_id": this.company_data.company_id ? this.company_data.company_id : '0',
      "code": this.public_reg_link,
    }

    if(requestObj)
    {
      console.log("Verification Payload: ", requestObj);
      // return;
    }
    

    this.webService.commonPostMethod("vendor/PublicRegistration/verifyPublicRegistrationLink", requestObj).
    subscribe(
      data => {
        if(data.status) {
          let response = data.response ? data.response : {};
          this.venRegComId = response.company_id ? response.company_id : "";
          this.venRegComToken = response.token ? response.token : "";
          this.companyTitle = response.company_name ? response.company_name : "";
          this.companyLogo = response.company_logo ? response.company_logo : "";
          
          this.isValidOpenLink = true;
          this.is_vendor_login = true;
          this.hideEmpLogin = true;
          data.self_ven_reg_msg = data.self_ven_reg_msg ? data.self_ven_reg_msg : "By registering I hereby agree to pay TYASuite or any other agency the Vendor Portal Charges of Rs. 1,200 plus GST/year. I understand that my access will be blocked if payment is not made within 3 working days.";
          this.company_setup.self_ven_reg_msg = data.self_ven_reg_msg;
        } else {
          data.message = data.message ? data.message : 'Something Went Wrong';
          this.toasterService.pop('error', 'Error', data.message);
        }
      }, error => {
        this.toasterService.pop('error', 'Error','Something Went Wrong');
      }
    );
  }
  sendOtpMsg : any = "";
  reSendOtp : boolean = false;
  sendOTP() {
    if(this.venReg.vendor_name == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor name.');
      return;
    }
    if(this.venReg.email == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor email.');
      return;
    } else {
      if (!this.validateEmail(this.venReg.email)) {
        this.toasterService.pop('info', 'Info', 'Please fill valid vendor email.');
        return;
      }
    }
    if(this.venReg.mobile == "") {
      this.toasterService.pop('info', 'Info', 'Please fill mobile no.');
      return;
    } else {
      if(!this.validmobile(this.venReg.mobile)) {
        this.toasterService.pop('info', 'Info', 'Please fill valid mobile no.');
        return;
      }
    }
    if(this.venReg.gstin == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor gst no.');
      return;
    }
    if(!this.isValidateGstSuccess) {
      this.toasterService.pop('info', 'Info', 'Please verify your GST No before proceedings.');
      return;
    }
    if(this.isWrongGst) {
      this.toasterService.pop('info', 'Info', 'Your GST Registration is not valid, please update the correct GST and proceed.');
      return;
    }

    this.showNewVenOTP = true;
    let requestObj = {
      "company_id": this.venRegComId,
      "code": this.public_reg_link,
      "email": this.venReg.email,
      "public_reg": this.public_reg ? '1' : '0',
      "venRegComToken": this.venRegComToken,
    }
    this.webService.commonPostMethod("vendor/PublicRegistration/generateOtp", requestObj).
    subscribe(
      data => {
        data.message = data.message ? data.message : "";
        if(data.status) {
          this.toasterService.pop('success', 'Success', data.message);
          this.sendOtpMsg = data.message;
          setTimeout(() => {
            this.reSendOtp = true;
            this.enableReGenOTP();
          }, 60000);
        } else {
          this.toasterService.pop('error', 'Error', data.message);
        }
      }, error => {
        this.toasterService.pop('error', 'Error','Something Went Wrong');
      }
    );  
  }

  generateVendor(elem) {
    if(this.venReg.vendor_name == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor name.');
      return;
    }
    if(this.venReg.email == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor email.');
      return;
    } else {
      if (!this.validateEmail(this.venReg.email)) {
        this.toasterService.pop('info', 'Info', 'Please fill valid vendor email.');
        return;
      }
    }
    if(this.venReg.mobile == "") {
      this.toasterService.pop('info', 'Info', 'Please fill mobile no.');
      return;
    } else {
      if(!this.validmobile(this.venReg.mobile)) {
        this.toasterService.pop('info', 'Info', 'Please fill valid mobile no.');
        return;
      }
    }
    if(this.venReg.gstin == "") {
      this.toasterService.pop('info', 'Info', 'Please fill vendor gst no.');
      return;
    }
    if(this.venReg.otp == "") {
      this.toasterService.pop('info', 'Info', 'Please fill otp sent to ' + this.venReg.email + ' .');
      return;
    }
    if(!this.isValidateGstSuccess) {
      this.toasterService.pop('info', 'Info', 'Please verify your GST No before proceedings.');
      return;
    }
    if(this.isWrongGst) {
      this.toasterService.pop('info', 'Info', 'Your GST Registration is not valid, please update the correct GST and proceed.');
      return;
    }
    // if(!this.isValidateGstSuccess || this.isWrongGst) {
    //   if(this.isWrongGst) {
    //     this.toasterService.pop('info', 'Info', 'Your GST Registration is not valid, please update the correct GST and proceed.');
    //     return;
    //   } else {
    //     this.toasterService.pop('info', 'Info', 'Please verify your GST No before proceedings.');
    //     return;
    //   }
    // }

    this.showNewVenOTP = true;
    let requestObj = {
      "company_id": this.venRegComId,
      "code": this.public_reg_link,
      "vendor_name": this.venReg.vendor_name,
      "email": this.venReg.email,
      "mobile": this.venReg.mobile,
      "gstin": this.venReg.gstin,
      "otp": this.venReg.otp,
      "public_reg": this.public_reg ? '1' : '0',
      "venRegComToken": this.venRegComToken,
      "isValidateGstSuccess": this.isValidateGstSuccess ? '1' : '0',
      "isCorrectGst": this.isWrongGst ? '0' : '1',
    }
    this.isvenRegProgressing = true;
    this.webService.commonPostMethod("vendor/PublicRegistration/registerVendor", requestObj).
    subscribe(
      data => {
        this.isvenRegProgressing = false;
        data.message = data.message ? data.message : "";
        if(data.status) {
          this.toasterService.pop('success', 'Success', data.message);
          this.reSendOtp = false;
          this.sendOtpMsg = "";
          elem.close();
          this.venReg = { "vendor_name": "", "email": "", "mobile": "", "gstin": "", "otp": "", }
          this.isValidateGstSuccess = false;
          this.isWrongGst = false;
          this.validateGstObj = {
            "name": "",
            "address": "",
            "pincode": "",
            "dst" : "",
            "gstin": "",
            "status": "",
          };
        } else {
          this.toasterService.pop('error', 'Error', data.message);
        }
      }, error => {
        this.isvenRegProgressing = false;
        this.toasterService.pop('error', 'Error','Something Went Wrong');
      }
    );
  }

  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validmobile(mobile) {
    let status = false;
    let no: number = mobile;
    let len: number = 0;
    if (mobile != '' && mobile != undefined) {
      len = mobile.toString().length;
      no = mobile;

      if (this.validateAllowNumber(no) && len == 10) {
        status = true;
      }
      else {
        status = false;
      }
    }
    return status;
  }

  validateAllowNumber(num) {
    let x = /^[0-9][0-9]{0,100}$/
    return x.test(num)
  }
  
  numberChange(event, max) {
    let value = event.target.value;

    if (value.length > max) {
      event.target.value = value.substr(0, max);
      this.toasterService.pop("info", "Info", "Maximum " + max + " digit");
      return false;
    }
  }

  validGst(gst) {
    let gstreg = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    let status = false;
    // Return false if gst is missing or not a string
    if (gst != undefined && gst != '') {
      if (gstreg.test(gst.toUpperCase())) {
        status = true;
      }
      else {
        status = false;
      }
    }else{
      status = false;;
    }
    return status;
  }

  checkgst(event) {
    let gstin = this.venReg.gstin ? this.venReg.gstin : "";
    if (this.originalGstinAfterValidation && gstin === this.originalGstinAfterValidation &&
    this.originalVendorNameAfterValidation && this.venReg.vendor_name == this.originalVendorNameAfterValidation) {
    this.gstinerror = "";
    this.isValidateGstSuccess = true;
    this.isWrongGst = false;
    this.isVendorNameEdited = false;
    return;
  }
    this.isWrongGst = false;
    this.isValidateGstSuccess = false;

    let gst = event;
    this.gstinerror = "";

    let gstreg = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    if (!this.validGst(event)) {
      this.gstinerror = "GST should be 15 digit with valid format";
    }
    else {
      this.gstinerror = "";
    }

    this.validateGstObj = {
      "name": "",
      "address": "",
      "pincode": "",
      "dst" : "",
      "gstin": "",
      "status": "",
    }
  }
  isVendorNameEdited: boolean = false;
  checkVenDetails (event, type) {
    // if(this.isValidateGstSuccess) {
      this.validateGstObj.name = this.validateGstObj.name ? this.validateGstObj.name : ""; 
      if(this.originalVendorNameAfterValidation && event == this.originalVendorNameAfterValidation) {
        // this.isValidateGstSuccess = false;
        // this.isWrongGst = true;
        this.isVendorNameEdited = false;
      } else {
        // this.isValidateGstSuccess = true;
        // this.isWrongGst = false;
        this.isVendorNameEdited = true;
      }
      this.isOnlyGstWrongAndNameCorrect = (!this.isVendorNameEdited && this.isWrongGst);
    // }
  }

  gstinerror: any = "";
  isValidateGstSuccess:boolean = false;
  validateGstObj:any = {
    "name": "",
    "address": "",
    "pincode": "",
    "dst" : "",
    "gstin": "",
    "status": "",
  };
  preValidateGstObj:any = {
    "name": "",
    "address": "",
    "pincode": "",
    "dst" : "",
    "gstin": "",
    "status": "",
  };
  isWrongGst : boolean = false;
  multiAddressData:any = [];
  validateGstCompleteData:any = {};
  preIsValidateGstSuccess:boolean = false;
  preIsWrongGst : boolean = false;
  perviousGstIn : any = "";
  originalVendorNameAfterValidation: any = "";
  originalGstinAfterValidation: any = "";
  isOnlyGstWrongAndNameCorrect: boolean = false;
  validateGst(elem1, elem2) {
    let gstin = this.venReg.gstin ? this.venReg.gstin : "";
    if(gstin == this.perviousGstIn) {
      return;
    }
    this.perviousGstIn = this.venReg.gstin ? this.venReg.gstin: "";
    this.multiAddressData = [];
    let obj = {
          "company_id": this._localStorageService.getEmpCompanyId() == undefined ? 0 : this._localStorageService.getEmpCompanyId(),
          "gst_no": this.venReg.gstin ? this.venReg.gstin: "",
      }
      this.webService.commonPostMethod("/Vendors/validateGstIn", obj).subscribe((data)=>{
        if(data.status){
          let tmpObj = data.response ? data.response : {};
          this.validateGstCompleteData = tmpObj
          tmpObj.cxdt = tmpObj.cxdt ? new Date(tmpObj.cxdt) : ""
          tmpObj.pradr = tmpObj.pradr ? tmpObj.pradr : {}
          tmpObj.pradr.addr = tmpObj.pradr.addr ? tmpObj.pradr.addr : {};
          this.validateGstObj = {
            "name": tmpObj.lgnm ? tmpObj.lgnm : "",
            "address": tmpObj.pradr.addr ? `${tmpObj.pradr.addr.bnm ? tmpObj.pradr.addr.bnm + "" + ",": ""} ${tmpObj.pradr.addr.flno ? tmpObj.pradr.addr.flno + "" + "," : ""} ${tmpObj.pradr.addr.bno ? tmpObj.pradr.addr.bno + "" + "," : ""} ${tmpObj.pradr.addr.st ? tmpObj.pradr.addr.st + "" + "," : ""} ${tmpObj.pradr.addr.loc ? tmpObj.pradr.addr.loc : ""}` : "",
            "pincode": tmpObj.pradr.addr ? `${tmpObj.pradr.addr.pncd ? tmpObj.pradr.addr.pncd : ""}` : "",
            "dst" : tmpObj.pradr.addr ? tmpObj.pradr.addr.dst : "",
            "gstin": tmpObj.gstin ? tmpObj.gstin : "",
            "status": tmpObj.sts ? tmpObj.sts : "",
            // "gst_status_as_per_gst": tmpObj.sts ? tmpObj.sts : "",
            // "date_of_gst_cancelation": tmpObj.cxdt ? this.webService.formatDate(tmpObj.cxdt, "dd-mm-yy", "-")  : "",
            // "gst_verification_date": this.webService.formatDate(new Date(), "dd-mm-yy", "-")
          }
          this.preValidateGstObj = this.validateGstObj;
          let legalName = data.response ? data.response.lgnm : "";
          legalName = legalName ? legalName.replace(/\s+/g, '').toLowerCase() : ""
          let fullName = this.venReg.vendor_name;
          fullName = fullName ? fullName.replace(/\s+/g, '').toLowerCase() : "";
          this.isWrongGst = tmpObj.sts == "Active" ? false : true;
          this.isValidateGstSuccess = true;
          this.preIsWrongGst = this.isWrongGst;
          this.preIsValidateGstSuccess = this.isValidateGstSuccess;
          // if(fullName != legalName) {
          //   elem2.close();
          //   elem1.open();
          // }
          this.venReg.vendor_name = this.validateGstObj.name ? this.validateGstObj.name : "";
          this.originalVendorNameAfterValidation = this.venReg.vendor_name;
          this.originalGstinAfterValidation = this.venReg.gstin;
          this.validateGstCompleteData = {};
        } else {
          this.toasterService.pop('info', 'Info', data.message);
          this.isValidateGstSuccess = false;
          this.isWrongGst = true;
          this.preIsWrongGst = this.isWrongGst;
          this.preIsValidateGstSuccess = this.isValidateGstSuccess;
          // this.gstinerror = data.message;
        }
      },errr=>{
        this.isWrongGst = true;
        this.isValidateGstSuccess = false;
        this.preIsWrongGst = this.isWrongGst;
        this.preIsValidateGstSuccess = this.isValidateGstSuccess;
        this.toasterService.pop('info', 'Info', "something went wrong");
      })
    }

    validateGstPopUp(type:any, elem1:any, elem2:any) {
      if(type == 'cancel') {
        // document.getElementById('validateGstin').style.display = "none";
        elem1.close();
        elem2.open();
      } else if(type == 'okay') {
        this.venReg.vendor_name = this.validateGstObj.name ? this.validateGstObj.name : "";
        // this.venReg.address = this.validateGstObj.address ? this.validateGstObj.address : "";
        // this.venReg.pincode = this.validateGstObj.pincode ? this.validateGstObj.pincode : "";
        // this.vendorData.city_id = this.getCityId(this.cityList.cities,this.validateGstObj.dst)

        // this.vendorFirstNameAddess(this.vendorData.first_name);
        // this.checkpincode(this.vendorData.pincode);
        // this.addressChangeInput(this.vendorData.address);
        // if(this.addressChangeType == "create"){
        //   this.AddressDetailsArray[0].name = this.vendorData.first_name ? this.vendorData.first_name : ""
        //   this.AddressDetailsArray[0].pincode = this.vendorData.pincode ? this.vendorData.pincode : '';
        //   this.AddressDetailsArray[0].address = this.vendorData.address
        //   this.AddressDetailsArray[0].city_id = this.vendorData.city_id ? this.vendorData.city_id : "";
        //   this.AddressDetailsArray[0].isValidateGstSuccess =  true

        // }
        // document.getElementById('validateGstin').style.display = "none";
        elem1.close();
        elem2.open();
        // if(this.multiAddressData.length > 0){
        //   document.getElementById('validateGstinIfMoreLocation').style.display = "block";
        // }
      }
    }

    ViewValidateGst(elem1:any, elem2:any) {
      if (Object.keys(this.validateGstCompleteData).length === 0) {
        
      } else {
        elem1.open();
        elem2.close();
        return;
      }
      this.validateGstCompleteData = {};
     let obj = {
          "company_id": this._localStorageService.getEmpCompanyId() == undefined ? 0 : this._localStorageService.getEmpCompanyId(),
          "gst_no": this.venReg.gstin ? this.venReg.gstin : "",
      }
      this.webService.commonPostMethod("/Vendors/validateGstIn", obj).subscribe((data)=>{
        if(data.status){
          // document.getElementById('ViewValidateGst').style.display = "block";
          elem1.open();
          elem2.close();
          let tmpObj = data.response ? data.response : {};
          this.validateGstCompleteData = tmpObj
        } else {
          this.toasterService.pop('info', 'Info', data.message);
        }
      },errr=>{
        this.toasterService.pop('info', 'Info', "something went wrong");
      })
      // document.getElementById('ViewValidateGst').style.display = "block";
    }

    ViewValidateGstClose(elem1:any, elem2:any) {
      // document.getElementById('ViewValidateGst').style.display = "none";
      elem1.close();
      elem2.open();
    }

  getDataFromCookie() {
    const cookieData = this.cookieService.get('companyDetail');
    if (cookieData) {
      const parsedData = JSON.parse(cookieData);
      this.cookieService.delete('companyDetail', '/');

      if(parsedData.public_reg_link && parsedData.public_reg_link != undefined && parsedData.public_reg_link != null)
      {
        let url = window.location.origin+'/#/login?public_reg=' + parsedData.public_reg_link;
        // console.log('url =>',url)
        window.location.href=url;
        window.location.reload();
      }
    }
    
  }
  restrictUserLoginWithEmailPassword(url) {
  let requestObj = {
    "url_host": (url == 'localhost' || url == '' || url == undefined) ? 'ad.intelaccounts.in' : window.location.hostname,
  };
  this.webService.commonPostMethod("Companies/restrict_user_login_with_email_password", requestObj)
    .subscribe(
      data => {
        data.is_disable = data.is_disable ? data.is_disable : '0';
        this.is_disable = data.is_disable ? data.is_disable:'';
        if (data.status) {
          this.title = data.response.title ? data.response.title : 'Login to your TYASuite Account.';
          this.background_image = data.response.background_image ? data.response.background_image : '';
          this.url_host = data.response.url_host ? data.response.url_host : '';
        }
        if (this.url_host == '' || this.url_host == undefined) {
          this.url_host = window.location.hostname == 'localhost' ? 'ad.intelaccounts.in' : window.location.hostname;
        }
      },
      error => {
      }
    );
}
}



// WEBPACK FOOTER //
// /codebuild/output/src2943604892/src/src/app/pages/login-v2/login-v2.component.ts